<template>
  <div>

    <!-- 选择数据 -->
    <div v-if="payType === ''" class="createAn4-box">
      <div class="laber-box intro-x">
        <div v-for="(item, index) in ceateData4" :key="index" class="laberItem-box" :class="{ isLaberTrue: payment === index }" @click="getPayment(index)">
          <div class="laberContent">
            <div class="itemLeftImg">
              <img :src="item.icon" alt="" />
            </div>
            <div class="itemRightText">
              <div class="item1">{{ item.title }}</div>
              <el-popover class="item" placement="top-start" width="600" trigger="hover" :content="item.content">
                <div class="item2" slot="reference">{{ item.content }}</div>
              </el-popover>
            </div>
          </div>
          <div v-show="payment === index" class="float-yuan" :class="{ 'el-icon-check': payment === index }"></div>
        </div>
      </div>

      <!-- 列表数据 -->
      <div class="table-box intro-x">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="功能模块" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scopeTitle">{{ scope.row.title }}</div>
            </template>
          </el-table-column>
          <el-table-column align="right" label="有效期" width="100" show-overflow-tooltip>
            <template>
              <span class="scopeDiscounts">一年</span>
            </template>
          </el-table-column>
          <el-table-column align="right" prop="money" label="金额" width="80" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>

      <div class="totalMoney-box intro-x mt-10">
        <div class="totalMoney-right">
          <div class="div1">总计金额</div>
          <!-- 使用 Vue filters过滤器  -->
          <div class="div2">¥ {{ (predictNum) | formatMoney }}</div>
          <div class="div3">共省 ¥{{ price_discount }}</div>
        </div>
      </div>

    </div>

    <!-- 视图 -->
    <div>
      <!-- 余额支付 -->
      <UserMoney v-if="payType === 'balance' && !paySuccess" ref="createAn"></UserMoney>
      <!-- 支付宝支付 -->
      <div v-if="payType === 'zfb'">
        <!-- 支付中 -->
        <div v-if="isGo">
          <div class="zhifubao">
            <div class="zhifubaoTextBox">
              <img src="@/assets/images/zhifubaoText.png" alt="" />
            </div>
<!--            <div v-if="isGO" class="text" style="padding-bottom: 50px">-->
<!--              <div style="margin-bottom: 10px">即将前往支付宝进行付款</div>-->
<!--              <i class="el-icon-loading" style="font-size: 25px"></i>-->
<!--            </div>-->
            <div class="text">
              <div style="margin-bottom: 40px">付款成功即可点击下一步进行创建</div>
            </div>
          </div>
        </div>
        <!-- 支付失败 -->
        <div v-if="!paySuccess && !isGo" class="error-box intro-x mt-10" style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
          <div class="succeed-png">
            <img src="@/assets/images/errors.png" alt="" style="width: 150px;" />
          </div>
          <div class="mt-2" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <div style="font-size: 16px; color: #333333">支付失败</div>
            <div style="font-size: 20px; color: #ff4242">
              ¥ {{ appData && appData.data && appData.data.price | formatMoney }}
            </div>
            <div style="font-size: 12px; color: #999999">
              失败原因：{{ appData && appData.msg || '未支付' }}
            </div>
          </div>
        </div>
      </div>
      <!-- 支付成功 -->
      <div v-if="paySuccess" class="succeed-box intro-x mt-10" style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
        <div class="succeed-png">
          <img src="@/assets/images/succeeds.png" alt="" />
        </div>
        <div class="mt-2" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <div style="font-size: 16px; color: #333333">支付成功</div>
          <div style="font-size: 20px; color: #1890ff">
            ¥ {{ appData && appData.data && appData.data.price | formatMoney }}
          </div>
          <div style="font-size: 12px; color: #999999">
            支付成功，点击下面按钮继续进行应用创建的步骤吧！
          </div>
        </div>
      </div>
    </div>


    <!-- 按钮 -->
    <div>
      <!-- 底部按钮 没有选择的状态 -->
      <div v-if="payType === ''" class="createrAn-Buttom-box" :style="'justify-content: center'">
        <div class="createrAn-Buttom intro-x">
        <span class="span0 span1" @click="handlePrev">
          上一步
        </span>
          <!-- 开始切换视图 -->
          <el-button :loading="isLoading" style="border: none; vertical-align: middle; line-height: 13px" class="span0 span2" @click="submitPay">
            下一步
          </el-button>
        </div>
      </div>

      <!-- 余额支付 底部按钮 -->
      <div v-if="payType === 'balance' && !paySuccess" class="createrAn-Buttom-box" :style="'justify-content: center'">
        <div class="createrAn-Buttom intro-x">
        <span class="span0 span1" @click="payType = ''">
            上一步
        </span>
          <!-- 开始切换视图 -->
          <span class="span0 span2" @click="balancePay()">
          付款
        </span>
        </div>
      </div>

      <!-- 支付宝支付中 底部按钮 -->
      <div v-if="payType === 'zfb' && isGo" class="createrAn-Buttom-box" :style="'justify-content: center'">
        <div class="button" @click="getPayResults()">
          我已完成支付，下一步
        </div>
      </div>

      <!-- 支付宝支付失败 底部按钮 -->
      <div v-if="payType === 'zfb' && !paySuccess && !isGo" class="createrAn-Buttom-box" :style="'justify-content: center'">
        <div class="createrAn-Buttom intro-x">
          <span class="span0 span1" @click="payType = ''" style="width: auto; padding-left: 12px; padding-right: 12px;">
            返回重新选择支付方式
          </span>
          <!-- 开始切换视图 -->
          <span class="span0 span2" @click="getPayResults()">
            重新查询
          </span>
        </div>
      </div>

      <!-- 支付成功 底部按钮 -->
      <div v-if="paySuccess" class="createrAn-Buttom-box" :style="'justify-content: center'">
        <div class="createrAn-Buttom intro-x">
          <!-- 开始切换视图 -->
          <span class="span0 span2" @click="handleNext">
          下一步
        </span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import UserMoney from '@/modules/createAn5'
import request from '@/utils/request'
import { createSupplyChain, calcBySupplyChain, initDatabase, initDomain } from '@/api/supply-chain/supply-chain'

export default {
  components: { UserMoney },
  props: ["planData"],
  data() {
    return {
      price_discount: 0,
      predictNum: 0,
      discount: 0,
      // 0 == 余额， 1 支付宝
      payment: -1,
      payType: '',
      // 支付状态
      paySuccess: false,
      // 支付宝 - 支付中
      zfbPayIng: false,
      ceateData4: [
        {
          icon: require("@/assets/images/qianbao.png"),
          title: "余额支付",
          content:
              "支持使用账户内余额支付，使用优惠码可享受折扣，价格更低，请提前充值保证余额充值",
        },
        {
          icon: require("@/assets/images/zhifubao.png"),
          title: "支付宝支付",
          content:
              "支持使用支付宝扫码支付，使用优惠码可享受折扣，一次付费，全年无忧，价格更低。",
        }
      ],
      tableData: [],
      payParams: {},
      // 查询状态返回
      appData: {},
      isLoading: false,
      isGo: false,
      uuid: ''
    }
  },
  mounted() {
    this.payment = -1
    this.payType = ''
    if (this.planData) {
      this.tableData = []
      this.planData.forEach(item => {
        // 总功能
        let totalFunction = 0
        const pushItem = {}
        if (item.modules) {
          item.modules.forEach(subItem => {
            if (subItem.optional === '0') {
              totalFunction++
            }
          })
        }
        pushItem.money = item.price
        pushItem.title = item.title + `内${totalFunction}功能`
        this.tableData.push(pushItem)
      })
    }
    this.getCalc()
  },
  methods: {
    // 切换视图
    handleChangeUI() {
      this.payType = this.payment === 0 ? 'balance' : 'zfb'
    },
    // 余额支付
    balancePay() {
      const params = this.payParams
      params.passcode = this.$refs.createAn.password
      createSupplyChain(params).then(resp => {
        if (resp.code === 0) {
          this.uuid = resp.data.uuid
          this.appData = resp
          this.paySuccess = true
        } else {
          this.paySuccess = false
        }
      })
    },
    // 开始创建
    submitPay() {
      if (this.payment === -1) {
        this.$message.error('请选择支付方式～')
        return
      }
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 2000)
      // 余额支付
      if (this.payment === 0) {
        this.payType = 'balance'
        return
      }
      this.payType = 'zfb'
      this.isGo = true
      const params = this.payParams
      // params.price = 0.01
      createSupplyChain(params).then(resp => {
        if (resp.code === 0) {
          // 支付宝支付
          if (this.payment === 1) {
            this.openURL = `/api/redirect/order/${resp.data.oid}`
            setTimeout(() => {
              window.open(this.openURL)
            }, 2000)
          }
        }
      })
    },
    // 下一步
    handleNext() {
      this._initDatabase()
      this._initDomain()
      this.$emit('handle-uuid', this.uuid)
      this.$emit('handle-next')
    },
    // 上一步
    handlePrev() {
      this.$emit('handle-prev')
    },
    // 计算
    getPayment(index) {
      this.payParams = {}
      this.payment = index
      this.getCalc()
    },
    // 后端计算价格
    async getCalc() {
      const params = {}
      params.pay_way = this.payment === -1 ? 1 : this.payment
      params.plan = []
      this.planData.forEach(item => {
        const pushItem = {}
        pushItem.id = item.plan_id
        pushItem.ext_modules = []
        if (item.modules) {
          item.modules.forEach(subItem => {
            if (subItem.optional === '0') {
              pushItem.ext_modules.push(subItem.mod_id)
            }
          })
        }
        params.plan.push(pushItem)
      })
      calcBySupplyChain(params).then(resp => {
        this.predictNum = resp.data.price
        this.discount = resp.data.discount
        this.price_discount = resp.data.price_discount
        this.payParams = resp.data
      })
    },
    // 支付宝 ---  我已经支付完成， 查询支付结果
    getPayResults() {
      this.isGo = false
      request({ url: `/api/order/check/${this.payParams.oid}`,}).then((res) => {
        this.appData = res;
        // 支付失败
        if (res.data.state === "0") {
          this.paySuccess = false
          this.zfbPayIng = false
          return
        }
        // 支付成功
        if (res.data.state === "1") {
          this.paySuccess = true
          this.zfbPayIng = false
          this.uuid = res.data.uuid
          return
        }
        this.paySuccess = false
        this.zfbPayIng = false
      }).catch(e => {
        this.paySuccess = false
        this.zfbPayIng = false
        console.log(e)
      })
    },
    // 初始化数据库
    _initDatabase() {
      const params = {}
      params.uuid = this.uuid
      initDatabase(params).then(resp => {
        if (resp.code !== 0) {
          this.$message.error(resp.msg + '\n联系管理员～')
        }
      }).catch(err => {
        this.$message.error(err + '\n联系管理员～')
      })
    },
    // 初始化站长域名
    _initDomain() {
      const params = {}
      params.uuid = this.uuid
      initDomain(params).then(resp => {
        if (resp.code !== 0) {
          this.$message.error(resp.msg + '\n联系管理员～')
        }
      }).catch(err => {
        this.$message.error(err + '\n联系管理员～')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.zhifubao {
  background: #fff;
}

.zhifubaoTextBox {
  width: 100%;
  text-align: center;
  margin: 97px 0 17px;
  img {
    display: inline-block;
    vertical-align: middle;
  }
}
.text {
  color: #333333;
  font-size: 18px;
  text-align: center;
}
.createTitle {
  margin: 41px 0 15px;
  color: #2d3748;
  font-size: 18px;
  display: block;
}

.createHtml-box {
  overflow: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
}

.createHtml {
  border-bottom: 1px solid #f5f5f5;
}

.createBody {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
}

.steps-box {
  padding: 40px 100px;
}

.createrAn-Buttom-box {
  widows: 100%;
  display: flex;
  width: 77.6%;
  padding: 40px 0 80px;
  margin: 0 auto;
  justify-content: space-between;
}

.createrAn-Buttom {
  .span0 {
    display: inline-block;
    width: 96px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }
  .span9 {
    display: inline-block;
    width: 208px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }

  .span1 {
    color: #788598;
    background: #edf1f6;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    color: rgb(235, 233, 233);
    background: #1890ff;
    margin-left: 20px;
  }
  .span2:active {
    background: #2d97fa;
  }
}

.loading8Clss {
  background: #e2f0ff !important;
  cursor: no-drop !important;
  color: #ffffff !important;
}

.button {
  width: 236px;
  height: 37px;
  background: #1890ff;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  color: #fff;
}

.button:active {
  background: #399fff;
}

@media screen and (max-width: 600px) {
  .createHtml {
    display: none !important;
  }

  .createrAn-Buttom {
    display: flex !important;
    padding: 20px !important;
    justify-content: center;
    align-items: center;
    .span2 {
      margin-left: 20px !important;
    }
  }
}
.createAn4-box {
  margin-top: 30px;
  padding: 0 10vw;
  overflow: hidden;
  box-sizing: border-box;
  .laber-box {
    width: 100%;
    overflow: hidden;
    display: flex;
    .laberItem-box {
      float: left;
      width: 50%;
      min-width: 86px;
      height: 120px;
      background: #fff;
      padding: 0.5vw;
      box-sizing: border-box;
      overflow: hidden;
      border: 1px solid #eef2f7;
      cursor: pointer;
      border-radius: 22px;
      margin: 0 2% 2% 0;
      position: relative;
    }
    .laberItem-box:last-child {
      margin: 0;
    }
  }
  .itemLeftImg {
    float: left;
    overflow: hidden;
    width: 48px;
    line-height: 6.7;
    img {
      width: 48px;
      height: 48px;
      vertical-align: middle;
      display: inline-block;
    }
  }
  .itemRightText {
    float: left;
    width: calc(100% - 48px);
    box-sizing: border-box;
    padding-left: 5%;
    padding-top: 15px;
  }
  .laberContent {
    display: inline-block;
    width: 100%;
    .item1 {
      color: #333333;
      font-size: 14px;
      text-align: left;
    }
    .item2 {
      font-size: 12px;
      color: #999999;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
  .float-yuan {
    width: 20px;
    height: 20px;
    background: #1890ff;
    border-radius: 50%;
    position: absolute;
    right: 20px;
    bottom: 10px;
    text-align: center;
    line-height: 20px;
    color: #ffffff;
    font-weight: bold;
    box-shadow: #e2e2e2 0px 0px 2px;
  }
  .isLaberTrue {
    border-color: #1890ff !important;
  }
}

.scopeTitle {
  color: #333;
  font-size: 14px;
}

.scopeCotnent {
  color: #999999 !important;
  font-size: 12px !important;
}

.promotionCode-box {
  overflow: hidden;
  margin-top: 13px;

  .promotionCode {
    float: left;
    width: 100%;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      margin-right: 10px;
      color: #333333;
      font-size: 14px;
    }
    .el-Input {
      display: inline-block;
      height: 40px;
      width: 465px;
    }
  }
  .promotionMoney {
    float: right;
    height: 40px;
    line-height: 40px;
    color: #ff4242;
    font-size: 14px;
  }
}

.totalMoney-box {
  overflow: hidden;
  .totalMoney-right {
    float: right;
    text-align: right;
    .div1 {
      font-size: 16px;
      color: #728196;
    }
    .div2 {
      color: #1890ff;
      font-weight: bold;
      font-size: 20px;
      margin: 4px 0;
    }
    .div3 {
      font-size: 14px;
      color: #394251;
    }
  }
}

.table-box-2 {
  display: none;
}

@media screen and (max-width:600px) {
  .table-box-2 {
    display: block;
  }
  .scopeformName {
    color: #999999;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .scopeTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .Code-title {
    color: #333333 !important;
    font-size: 15px !important;
    padding-left: 6px !important;
    border-left: #1890ff 4px solid !important;
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .table-box {
    display: none !important;
  }

  .createAn4-box {
    padding: 0 4vw !important;
    .laber-box {
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .totalMoney-box {
    margin-top: 1rem !important;
  }

  .laberItem-box {
    width: 100% !important;
    margin-right: 0 !important;
    padding-left: 20px !important;
  }
  .el-Input {
    width: 100% !important;
  }
  .money-color {
    color: #1890FF;
    font-size: 13px;
  }
}
</style>
